import { createContext } from 'react';

import { ModalContextValue } from '../types';

function invalidMethod(..._args: unknown[]): unknown {
    throw new Error('Use AvailabilityPickerContext outside of Provider');
}

export const availabilityPickerContext = createContext<ModalContextValue>({
    isOpen: null!,
    setOpen: invalidMethod,
});
